var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.417 0.75V16.3359L31.0664 29.583H26.71L32.0176 17.6377L32.4863 16.583H23.5V0.75H40.417ZM17.667 0.75V16.3359L8.31641 29.583H3.95996L9.26758 17.6377L9.73633 16.583H0.75V0.75H17.667Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteI);
export default __webpack_public_path__ + "static/media/quote-i.05e2ed15b44b20734f9aaa11de2cf91a.svg";
export { ForwardRef as ReactComponent };